var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyViewMiddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 90,
    viewBox: "0 0 39 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5 22.5C25.718 22.5 30.75 17.468 30.75 11.25C30.75 5.03203 25.7109 0 19.5 0C13.2891 0 8.25 5.03906 8.25 11.25C8.25 17.4609 13.2891 22.5 19.5 22.5ZM27 30H12C5.78906 30 0.75 35.0391 0.75 41.25V52.5C0.75 56.6414 4.10859 60 8.25 60V82.5C8.25 86.6414 11.6086 90 15.75 90H23.25C27.3914 90 30.75 86.6414 30.75 82.5V60C34.8914 60 38.25 56.6414 38.25 52.5V41.25C38.25 35.0391 33.2109 30 27 30Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyViewMiddle);
export default __webpack_public_path__ + "static/media/familyViewMiddle.256ba19049208f2da4b5d4c0bf8c9259.svg";
export { ForwardRef as ReactComponent };